import React, { memo } from 'react';
import { LabelWrapper, LabelCircle, LabelText } from './styles';

const LineChartLabels = ({ labels, getColor }) => {
  if (!labels || !labels.length) return null;

  return labels.map((label, i) => (
    <LabelWrapper key={i}>
      <LabelCircle color={getColor(i)}>&nbsp;</LabelCircle>
      <LabelText>{label}</LabelText>
    </LabelWrapper>
  ));
};

export default memo(LineChartLabels);
